export const CreatedViaTsysApiWarning = "Automatically created via TSYS API";
